module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-H.2a996aa6.png";